import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import cs from './locales/cs.json';

const getLanguageByLocation = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (timezone === 'Europe/Prague') {
      return 'cs';
    }

    const germanTimezones = [
      'Europe/Berlin',
      'Europe/Vienna',
      'Europe/Zurich',
      'Europe/Vaduz',
    ];

    if (germanTimezones.includes(timezone)) {
      return 'de';
    }

    return 'en';
  } catch (error) {
    return 'cs';
  }
};

const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    return savedLanguage;
  }
  return getLanguageByLocation();
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      cs: { translation: cs }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'cs',
    interpolation: {
      escapeValue: true
    }
  });

export default i18n;